import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import apiTutorial from "@/api/tutorial";

const defaultState = () => ({
    konfirmResponse: {},
    dataListTutorial: [],
    tutorialCategory: [],
    dataDetailTutorial: {},
    pagination: {},
    alert: '',
    progress: false,
});

const state = defaultState();

const getters = {};

const mutations = {
    listDataTutorial(state, data) {
        state.dataListTutorial = {};
        state.pagination = {};
        state.dataListTutorial = data.data;
        state.pagination = data.pagination;
    },
    listTutorialCategory(state, data) {
        state.tutorialCategory = data.data.results;
    },
    detailTutorial(state, data) {
        state.dataDetailTutorial = data.data;
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = {};
        state.konfirmResponse = data;
    },
    reset(state) {
        Object.assign(state, defaultState());
    },
};

const actions = {
    getDataTutorial({ commit }, value){
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            apiTutorial.dataTutotrial(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataTutorial', { data: 'error', pagination: data.pagination });
                } else {    
                    commit("listDataTutorial", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            apiTutorial.dataTutotrial({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataTutorial', { data: 'error', pagination: data.pagination });
                } else {
                    commit("listDataTutorial", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },
    getDetailTutorial({ commit }, value){
        commit(PROGRESS_START, null, { root: true });
        apiTutorial.detailTutorial({ 'id': value.id }).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('detailTutorial', { data: 'error' });
            } else {
                commit("detailTutorial", { data: data.results });
            }
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },
    getOptionTutorailCategory({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        apiTutorial.dataOptionTutorialCategory().then(( { data } ) => {
            if(data.code == 200) {
                commit("listTutorialCategory", data);
                commit("saveConfirmResponse", data);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};